export const nativeShare = async (shareData) => {
  let webShareStatus = '';

  if (!navigator.canShare || !navigator.canShare(shareData)) {
    webShareStatus = 'unsupported';
    return false;
  }

  try {
    await navigator.share(shareData);
    webShareStatus = 'success';
  } catch (err) {
    console.warn('There was an error sharing this product on your device: ', err);
    if (err.name === 'AbortError') {
      webShareStatus = 'aborted';
    } else {
      webShareStatus = 'failed';
    }
  }

  if (['success', 'aborted'].includes(webShareStatus)) {
    return true;
  }
};
